app.directive('issueButton', ['$translate', '$mdDialog', 'meedy.userModel',
    function($translate, $mdDialog, userModel) {
        var definition = {
            restrict: 'E',
            replace: true,
            templateUrl: 'edm/application/directive/issueButton/template/issue-button.html',
            link: function($scope, element, attr, formCtrl) {
                var pwz = userModel.currentUser.pwz;
                var pwzPresent = pwz && pwz != '';
                var isViprotect = userModel.currentUser.originSystem === Enum.ORIGIN_SYSTEM.MEEDY_PROTECT;

                if(typeof attr.iconButton !== 'undefined') {
                    $scope.iconButton = true;
                }

                if(isViprotect) {
                    $scope.medicalTemplates = [
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.E_REFERRAL'),
                            action: function () {
                                $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.E_REFERRAL, false);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.REFERRAL_HOSPITAL'),
                            action: function () {
                                return $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.HOSPITAL, false);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.REFERRAL_DIAGNOSTIC'),
                            action: function () {
                                return $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.DIAGNOSTIC, false);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.REFERRAL_LABORATORY'),
                            action: function () {
                                return $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.LABORATORY, false);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.REFERRAL_LABORATORY_FOR_NOT_PHYSICIANS'),
                            action: function () {
                                return $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.LABORATORY, false);
                            },
                            visible: !pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.REFERRAL_ALAB'),
                            action: function () {
                                return $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.ALAB, false);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.ALAB_DELEGATION'),
                            action: function () {
                                return $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.ALAB, false);
                            },
                            visible: !pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.SICK_LEAVE'),
                            action: function () {
                                return $scope.openSickLeavePopup();
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.INSURANCE_STATEMENT_N_9'),
                            action: function () {
                                return $scope.openInsuranceStatement(Enum.INSURANCE_STATEMENT_TYPE.N9);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.INSURANCE_STATEMENT_N_14'),
                            action: function () {
                                return $scope.openInsuranceStatement(Enum.INSURANCE_STATEMENT_TYPE.N14);
                            },
                            visible: pwzPresent
                        }
                    ];
                } else {
                    $scope.medicalTemplates = [
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.PRESCRIPTION_RP'),
                            action: function () {
                                $scope.openMedicalTemplatePopup(Enum.PRESCRIPTION_TYPE.RP);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.PRESCRIPTION_RPW'),
                            action: function () {
                                $scope.openMedicalTemplatePopup(Enum.PRESCRIPTION_TYPE.RPW);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.PRESCRIPTION_RCP'),
                            action: function () {
                                $scope.openMedicalTemplatePopup(Enum.PRESCRIPTION_TYPE.RCP);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.E_REFERRAL'),
                            action: function () {
                                $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.E_REFERRAL, false);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.REFERRAL_SPECIALIST'),
                            action: function () {
                                $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.SPECIALIST, false);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.REFERRAL_HOSPITAL'),
                            action: function () {
                                return $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.HOSPITAL, false);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.REFERRAL_DIAGNOSTIC'),
                            action: function () {
                                return $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.DIAGNOSTIC, false);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.REFERRAL_LABORATORY'),
                            action: function () {
                                return $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.LABORATORY, false);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.REFERRAL_LABORATORY_FOR_NOT_PHYSICIANS'),
                            action: function () {
                                return $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.LABORATORY, false);
                            },
                            visible: !pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.REFERRAL_ALAB'),
                            action: function () {
                                return $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.ALAB, false);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.ALAB_DELEGATION'),
                            action: function () {
                                return $scope.openReferralPopup(null, Enum.REFERRAL_TYPE.ALAB, false);
                            },
                            visible: !pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.SICK_LEAVE'),
                            action: function () {
                                return $scope.openSickLeavePopup();
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.INSURANCE_STATEMENT_N_9'),
                            action: function () {
                                return $scope.openInsuranceStatement(Enum.INSURANCE_STATEMENT_TYPE.N9);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: $translate.instant('T.MODULE.VISIT.MEDICAL_TEMPLATES.INSURANCE_STATEMENT_N_14'),
                            action: function () {
                                return $scope.openInsuranceStatement(Enum.INSURANCE_STATEMENT_TYPE.N14);
                            },
                            visible: pwzPresent
                        },
                        {
                            name: 'Echo serca',
                            action: function () {
                                return $scope.openHeartEchoPopup();
                            },
                            visible: pwzPresent
                        },
                        {
                            name: 'Info dla lek. kierującego/POZ',
                            action: function () {
                                return $scope.openReferralToClinicPopup();
                            },
                            visible: pwzPresent
                        }
                    ];
                }

            }
        };

        return definition;
    }
]);
